<template>
  <div class="getCode">
    <div class="page_top">
      <van-icon class="uploadPage_back" name="arrow-left" @click="backClick" />
      <div class="page_top_title">社区登录码获取步骤</div>
    </div>
    <div class="getCode_content">
      <div class="getCode_content_blok">
        <p class="getCode_content_blok_title">第一步</p>
        <p>打开龙之国游戏，找到“社区”图标</p>
        <p class="getCode_content_blok_red">
          社区需要游戏角色15级解锁，如果未达到，努力升级哦~
        </p>
        <img class="getCode_content_blok_img" src="@/assets/img/login/login_step1.png" />
      </div>
      <div class="getCode_content_blok">
        <p class="getCode_content_blok_title">第二步</p>
        <p>打开“社区”，先点击到“我的”，再找到“设置”图标</p>
        <img class="getCode_content_blok_img blok2_img" src="@/assets/img/login/login_step2.png" />
      </div>
      <div class="getCode_content_blok">
        <p class="getCode_content_blok_title">第三步</p>
        <p>打开“设置”，点进“社区登录码”，即可获取社区登录码</p>
        <img class="getCode_content_blok_img blok3_img" src="@/assets/img/login/login_step3.png" />
      </div>
      <div class="getCode_content_bottomtext">
        若以上步骤还不能解决您的问题，请联系客服
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "getCode",
  methods: {
    backClick() {
      this.$emit("goGetcode", false);
    },
  },
};
</script>
<style scoped>
</style>